import { createVanIconComponent } from "./van"

const UserCircleOutlined = createVanIconComponent("user-circle-o")
export default UserCircleOutlined
